/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import Context from "../../scripts/context/User";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import ChangePassword from "../../components/ChangePassword";
import TwoFASwitch from "../../components/TwoFASwitch";
import toast from "react-hot-toast";

export default function Profile() {
  const { globalState, setGlobalState } = useContext(Context);
  const [values, setValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    street: "",
    city: "",
    zip_code: "",
    country: "",
    invitation_code: "",
  });
  const [status, setStatus] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get("/register/account_status/getAccountSummary")
      .then(({ data: apiData }) => {
        setValues(apiData.data.personal_info.values);
        setStatus(apiData.data.personal_info.values.two_fa);
        setLoading(false);
      })
      .catch(({ response }) => {
        console.log(response.data.message);
        setLoading(false);
      });
  }, []);

  const uploadUserAvatar = (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("avatar", file);
    axios
      .post("/profile/change-avatar", formData)
      .then(({ data }) => {
        setGlobalState({
          user: {
            ...globalState.user,
            avatar: data.avatar,
          },
        });
      })
      .catch(({ response }) => {
        console.log(response.data.message);
      });
  };

  if (!globalState.user) return <Navigate to="/login" />;
  if (loading)
    return (
      <CircularProgress
        sx={{
          position: "absolute",
          right: "50%",
          bottom: "50%",
        }}
      />
    );

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="d-flex flex-column-fluid">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="card card-custom card-stretch">
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                      <div
                        className="image-input image-input-outline"
                        id="kt_profile_avatar"
                        style={{
                          backgroundImage: `url(${globalState.user.avatar})`,
                        }}
                      >
                        <div
                          className="image-input-wrapper"
                          style={{
                            backgroundImage: `url(${globalState.user.avatar})`,
                            height: "80px",
                            width: "80px",
                            backgroundPosition: "center",
                          }}
                        ></div>
                        <label
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow just-white"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Change avatar"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <rect x="0" y="0" width="24" height="24" />
                              <path
                                d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                                fill="#c2c2c3"
                                fill-rule="nonzero"
                                transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                              />
                              <rect
                                fill="#c2c2c3"
                                opacity="0.3"
                                x="5"
                                y="20"
                                width="15"
                                height="2"
                                rx="1"
                              />
                            </g>
                          </svg>
                          <input
                            type="file"
                            name="profile_avatar"
                            accept=".png, .jpg, .jpeg"
                            onChange={uploadUserAvatar}
                            hidden
                          />
                          <input type="hidden" name="profile_avatar_remove" />
                        </label>
                      </div>
                    </div>
                    <div>
                      <span className="font-weight-bolder font-size-h5 text-hover-primary">
                        {globalState.user.full_name}
                      </span>
                    </div>
                  </div>
                  <div className="py-5">
                    <h5 className="font-weight-bold mt-5 mb-6 border-bottom pb-3">
                      Personal information
                    </h5>
                    {[
                      { label: "First Name", name: "first_name" },
                      { label: "Last Name", name: "last_name" },
                      { label: "Email", name: "email" },
                      { label: "Mobile", name: "mobile" },
                      { label: "Invitation Code", name: "invitation_code" },
                    ].map((item, index) =>
                      values[item.name] ? (
                        <div
                          key={index}
                          className="d-flex align-items-center justify-content-between pb-3 mb-4"
                        >
                          <span className="font-weight-bold mr-2">
                            {item.label}
                          </span>
                          {item.name === "invitation_code" ? (
                            <span
                              className="text-muted text-hover-primary cursor-pointer"
                              onClick={() => {
                                navigator.clipboard
                                  .writeText(
                                    `${
                                      window.location.origin
                                    }/register/personal-information?invitation_code=${
                                      values[item.name]
                                    }`
                                  )
                                  .then(function () {
                                    toast.success("Copied to clipboard");
                                  })
                                  .catch(() => {
                                    console.log(
                                      `${
                                        window.location.origin
                                      }/register/personal-information?invitation_code=${
                                        values[item.name]
                                      }`
                                    );
                                  });
                              }}
                            >
                              {values[item.name]}
                              <i className="ml-3 fa-solid fa-copy" />
                            </span>
                          ) : (
                            <span className="text-muted text-hover-primary">
                              {values[item.name]}
                            </span>
                          )}
                        </div>
                      ) : (
                        <></>
                      )
                    )}
                    <h5 className="font-weight-bold mt-10 mb-6 border-bottom pb-3">
                      Residential Address
                    </h5>
                    {[
                      { label: "Street Address", name: "street" },
                      { label: "City", name: "city" },
                      { label: "Zip Code", name: "zip_code" },
                      { label: "Country", name: "country" },
                    ].map((item, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between pb-3 mb-4"
                      >
                        <span className="font-weight-bold mr-2">
                          {item.label}
                        </span>
                        <span className="text-muted">{values[item.name]}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card card-custom card-stretch">
                <div className="card-header py-3">
                  <div className="card-title align-items-start flex-column justify-content-center">
                    <h3 className="card-label font-weight-bolder text-dark">
                      Profile Settings
                    </h3>
                  </div>
                </div>
                <form
                  className="form"
                  onSubmit={(event) => event.preventDefault()}
                >
                  <div className="card-body pt-0">
                    <div className="row">
                      <label className="col-xl-3"></label>
                      <div className="col-lg-9 col-xl-6">
                        <h5 className="font-weight-bold mt-10 mb-6">
                          Change Password
                        </h5>
                      </div>
                    </div>
                    <ChangePassword />

                    <div className="row border-top mt-10">
                      <label className="col-xl-3"></label>
                      <div className="col-lg-9 col-xl-9">
                        <h5 className="font-weight-bold mt-10 mb-6">
                          Google Authentication
                        </h5>
                      </div>
                    </div>
                    <TwoFASwitch status={status} setStatus={setStatus} />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
